module.exports = __webpack_public_path__ + "img/curve.f09f47e3.svg";